import { COUNTRIES_ICONS_BASE_URL } from '../constants/countriesIconsBaseUrl'

export const getCountryIconUrl = (icon?: string) =>
  icon ? `${COUNTRIES_ICONS_BASE_URL}circle-flags/${icon}.svg` : undefined
